module.exports = __webpack_public_path__ + "slide12.162f1baf7672c161f121.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide12.jpg
// module id = ./src/assets/images/private/home/slide12.jpg
// module chunks = main